import { filter, map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

interface BroadcastEvent {
  key: any;
  data?: any;
}

/**
 * todo: check what this is doing, have a good idea but it's provided at component level and not marked injectable?
 *
 * todo: doesn't actually look used? find an invocation
 */
export class BroadcastService {
  private _eventBus: Subject<BroadcastEvent>;

  constructor() {
    this._eventBus = new Subject<BroadcastEvent>();
  }

  broadcast(key: any, data?: any) {
    this._eventBus.next({ key, data });
  }

  on<T>(key: any): Observable<T> {
    return this._eventBus.pipe(
      filter((event) => event.key === key),
      map((event) => <T>event.data),
    );
  }
}
